import en from "./en";
import it from "./it";
import es from "./es";

const dicts = { en, it, es };

export const languages = [
  { code: "it", label: "Italiano" },
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
];

export const currencies = [
  { code: "EUR", symbol: "€", label: "Euro (€)" },
  { code: "GBP", symbol: "£", label: "Pound (£)" },
];

function lookup(dict, key) {
  return key.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
}

export function translate(lang, key, params) {
  const val = lookup(dicts[lang] || dicts.it, key) ?? lookup(dicts.it, key) ?? key;
  if (typeof val !== "string") return key;
  return params ? val.replace(/\{(\w+)\}/g, (_, k) => (params[k] ?? "")) : val;
}
